import { jsx as _jsx } from "react/jsx-runtime";
import { toTextColorClassName } from '../../config/Colors.js';
import { toClassName } from '../../utils/ClassNameUtils.js';
import { toSpacingClassName } from '../../utils/LayoutPropsUtils.js';
import { toTextStyleClassName } from '../../utils/TextStylePropsUtils.js';
export function Text({ as, id, className, textStyle, color, style, children, ...props }) {
    const Element = as ?? 'p';
    return (_jsx(Element, { className: toClassName(toTextStyleClassName(textStyle), className, toTextColorClassName(color), toSpacingClassName(props)), id: id, style: style, children: children }));
}
//# sourceMappingURL=Text.js.map